import { render, staticRenderFns } from "./highlight-match.vue?vue&type=template&id=09bf9f5c&scoped=true&"
import script from "./highlight-match.vue?vue&type=script&lang=js&"
export * from "./highlight-match.vue?vue&type=script&lang=js&"
import style0 from "./highlight-match.vue?vue&type=style&index=0&id=09bf9f5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bf9f5c",
  null
  
)

export default component.exports